import React from 'react';
import styled from 'styled-components';
import { useTheme } from '@material-ui/core';

const Box = ({ label, children }) => {
  const { palette } = useTheme();
  return (
    <Container background={palette.primary.dark} label={label}>
      {label && <Label background={palette.primary.dark}>{label}</Label>}
      {children}
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  background-color: ${(props) => props.background};
  padding: 1rem;
  border: 1px solid;
  border-radius: ${(props) => (props.label ? '0 1rem 1rem 1rem' : '1rem')};
  margin-top: ${(props) => (props.label ? '3rem' : '1rem')};
`;

const Label = styled.div`
  background-color: ${(props) => props.background};
  padding: 3px 10px 0 10px;
  position: absolute;
  top: -23px;
  left: -1px;
  border: 1px solid;
  border-bottom: none;
  border-radius: 1rem 1rem 0 0;
  font-weight: 700;
  font-style: italic;
`;

export default Box;
